module.exports = __webpack_public_path__ + "img/s8Bg2.a52bc846.jpg";